import { Icon, IconProps } from "../";

export const CancelOvalIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47714 6.47714 2 12 2C17.5214 2 22 6.47714 22 12C22 17.5214 17.5214 22 12 22C6.47714 22 2 17.5214 2 12ZM7.05025 8.11091C6.75736 7.81802 6.75736 7.34315 7.05025 7.05025C7.34315 6.75736 7.81802 6.75736 8.11091 7.05025L12 10.9393L15.8891 7.05025C16.182 6.75736 16.6569 6.75736 16.9497 7.05025C17.2426 7.34315 17.2426 7.81802 16.9497 8.11091L13.0607 12L16.9497 15.8891C17.2426 16.182 17.2426 16.6569 16.9497 16.9497C16.6569 17.2426 16.182 17.2426 15.8891 16.9497L12 13.0607L8.11091 16.9497C7.81802 17.2426 7.34315 17.2426 7.05025 16.9497C6.75736 16.6569 6.75736 16.182 7.05025 15.8891L10.9393 12L7.05025 8.11091Z"
      />
    </Icon>
  );
};
